import { useLanguage } from "@/contexts/LanguageContext";
import { getLocalizedPath } from "@/lib/getLocalizedPath";
import { Globe } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export const LanguageSwitcher = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  // Solo navega: el idioma sale de la URL nueva (useLanguageFromUrl en RootLayout)
  const handleLanguageChange = (newLang: string) => {
    navigate(getLocalizedPath(location.pathname, newLang));
  };

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-primary" />
      <select
        value={language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="bg-transparent text-primary hover:bg-primary/10 border-none outline-none text-sm font-light transition-all duration-200 rounded-full px-2 py-1 cursor-pointer"
      >
        <option value="es" className="text-foreground bg-background">Español</option>
        <option value="en" className="text-foreground bg-background">English</option>
        <option value="pt" className="text-foreground bg-background">Português</option>
        <option value="fr" className="text-foreground bg-background">Français</option>
      </select>
    </div>
  );
};
